import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAuth } from 'user-auth'
import { ROLES } from '~workspace/constants/roles'
import {
  setIsWorkspaceMember,
  setIsWorkspaceOwner,
  useWorkspace,
  useWorkspaceError,
  useWorkspaceLoading
} from '~workspace/states/workspace'

const useGetWorkspaceById = (workspaceId) => {
  const dispatch = useDispatch()

  const { user, authenticated } = useAuth()
  const loading = useWorkspaceLoading()
  const error = useWorkspaceError()
  const workspace = useWorkspace()

  if (!workspaceId) throw new Error('missing workspaceId')

  useEffect(() => {
    const setup = () => {
      const membership =
        authenticated && getWorkspaceMembership({ workspace, user })

      const isOwner = membership?.role === ROLES.OWNER
      const isMember = !!membership

      dispatch(setIsWorkspaceOwner(isOwner))
      dispatch(setIsWorkspaceMember(isMember))
    }
    if (workspaceId) setup()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId, user, authenticated])

  return { loading, workspace, error }
}

export { useGetWorkspaceById }

const getWorkspaceMembership = ({ workspace, user }) => {
  return workspace.memberCollection.items.find(
    (member) => member.user.id === user.id
  )
}
